import { useEffect } from "react";
import { Message, Button, Icon } from "semantic-ui-react";
import PageWrap from "components/PageWrap/PageWrap";
import TransitionBetween from "components/TransitionBetween/TransitionBetween";
import DeliveryUpload from "components/DeliveryUpload/DeliveryUpload";
import DeliveryCodeForm from "forms/DeliveryCode";
import DeliveryForm from "forms/Delivery";
import CampaignForm from "forms/Campaign";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { STEPS } from "store/models/deliverNew";
import { Redirect } from "react-router";

function DeliverNewPage() {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const { step, goingBackwards, campaign, assetActions, assets } = useSelector(
    (state) => state.deliverNew
  );
  useEffect(() => dispatch.deliverNew.reset, []);

  const content = () => {
    switch (step) {
      /**
       * * STEP.INIT => contributor input the 'deliver code' & click 'search'-button
       *
       * */
      case STEPS.INIT:
      default:
        return (
          <DeliveryCodeForm
            onCampaign={dispatch.deliverNew.onCampaignSelect}
            onHasDeliveries={dispatch.deliverNew.onCampaignRedirect}
            onNoCampaign={dispatch.deliverNew.onNoCampaign}
          />
        );
      case STEPS.CREATE_CAMPAIGN:
        return (
          <CampaignForm
            campaign={campaign}
            onSuccess={dispatch.deliverNew.onCampaignCreate}
            goPrev={dispatch.deliverNew.goBack}
          />
        );
      case STEPS.CREATE_ASSETS:
        return (
          <DeliveryForm
            campaign={campaign}
            dispatch={dispatch}
            onSuccess={dispatch.deliverNew.upload}
            goPrev={dispatch.deliverNew.goBack}
          />
        );
      case STEPS.REDIRECT_TO_CAMPAIGN:
        return <Redirect to={`/deliveries/${campaign.id}`} />;
      case STEPS.UPLOAD:
        return (
          <DeliveryUpload
            actions={assetActions}
            onSuccess={dispatch.deliverNew.success}
            campaign={campaign}
          />
        );
      case STEPS.SUCCESS:
        return (
          <DeliverySuccess campaign={campaign} assets={assets} reset={dispatch.deliverNew.reset} />
        );
    }
  };

  return (
    <PageWrap page="deliverNew" t={t} dispatch={dispatch}>
      <TransitionBetween enter="fly left" exit="fly right" reverse={goingBackwards} duration={500}>
        <div className="page-container" key={step}>
          {content()}
        </div>
      </TransitionBetween>
    </PageWrap>
  );
}

const DeliverySuccess = (props) => {
  const { campaign, assets, reset } = props;
  const { t } = useTranslation("common");
  const msg =
    campaign && assets ? (
      <span>
        {t("deliver_new_page_created_campaign", {
          campaignName: campaign.name,
          assetsNumber: assets.length,
        })}
      </span>
    ) : (
      (!campaign ? "campaign is undefined" : "") + (!assets ? ", assets are undefined" : "")
    );

  return (
    <>
      <Message success icon>
        <Icon name="check" />
        {msg}
      </Message>
      <Button primary onClick={reset}>
        {t("deliver_new_page_send_new")}
      </Button>
      <Button primary onClick={reset}>
        {t("deliver_new_page_edit_campaign")}
      </Button>
    </>
  );
};

export default DeliverNewPage;
